export default __webpack_public_path__ + "static/media/leather_side_NORM-min.d328c29b.png";